import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { Button, Icon, Modal } from '@octano/global-ui';

import { TranslationsKeys } from '../../../../../../locales/translations';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function IncompleteCoursesModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION_DETAIL);

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <Row className="pb-4">
        <Col xs={12} className="text-center pb-4">
          <Icon name="warning" size="56px" color="secondary" />
        </Col>
        <Col xs={12} className="text-center">
          <h1 className="text-dark fs-22">{t('incompleteModal.title')}</h1>
        </Col>
        <Col xs={12} className="text-center pt-3">
          <p className="fs-16 fw-300">{t('incompleteModal.message')}</p>
        </Col>
      </Row>
      <Row className="pb-2 pt-4">
        <Col className="mx-auto" xs={12} sm={6}>
          <Button
            text={t('incompleteModal.confirm')}
            fullwidth
            onClick={onClose}
          />
        </Col>
      </Row>
    </Modal>
  );
}
